export default "__VITE_ASSET__1ba8d01c__"